/**
 * File: select_filter_article_list.tsx
 * Description: Renders a grouped, scrollable list of FAQ articles organised by category.
 * Each article links to its detail page. When no articles match the current filter an
 * empty-state message is displayed instead.
 */

import ListItemButton from '@mui/material/ListItemButton';
import CategoryArticlesList from '@/components/global/category_articles_list';
import CategoryArticlesListTextItem from '@/components/global/category_articles_list_text_item';
import type { Category } from '@/interfaces/category';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Props for the SelectFilterArticleList component.
 *
 * @property {Category[]} categories - Array of FAQ categories, each containing the articles
 *   that matched the current filter. Categories with an empty articles array are skipped.
 */
interface FilterArticleListProps {
  categories: Category[];
}

/**
 * Displays a grouped list of FAQ articles filtered by category, each linking to its
 * detail page.
 *
 * @param {Category[]} props.categories - The filtered categories to display.
 * @returns {JSX.Element}
 */
function SelectFilterArticleList({ categories }: FilterArticleListProps) {
  return (
    <CategoryArticlesList
      categories={categories}
      itemContent={(category, article) => (
        <ListItemButton
          component={RouterLink}
          to={`/articulo?idcategoria=${String(category.id)}&idarticulo=${String(article.id)}`}
        >
          <CategoryArticlesListTextItem
            title={article.title}
            creationDate={article.creation_date}
          />
        </ListItemButton>
      )}
    />
  );
}

export default SelectFilterArticleList;
